import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import MatchWorkSelection from './MatchWorkSelection'
import MatchConfirmation from './MatchConfirmation'
import { StoresContext } from '@App/contexts'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import MatchSearch from '@Scenes/RightsholderScene/MatchClaim/Match/MatchSearch'

const MatchScene = () => {
    const [step, goToStep] = useState(1)
    const { matchingStore } = useContext(StoresContext)

    useEffect(() => {
        analyticsSendPage('match')
        return () => {
            matchingStore.resetStore()
        }
    }, [])

    switch (step) {
        case 3:
            return <MatchConfirmation goToStep={goToStep} matchingStore={matchingStore} />
        case 2:
            return <MatchWorkSelection goToStep={goToStep} matchingStore={matchingStore} />
        default:
            return <MatchSearch goToStep={goToStep} />
    }
}

export default observer(MatchScene)
